import { uiSettingsDefaults } from '../reducers/UiSettingsReducers';

/**
 * @description Removes team from uiSettings
 */
export default (state: any) => {
  return {
    ...state,
    uiSettings: {
      ...state.uiSettings,
      team: uiSettingsDefaults.team,
    },
  };
};
